import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import ChallengesByUser from '../components/ChallengesByUser';

const MPPStatsChallenges = () => (
  <div id="league-MPP">
    <header className="content-header">
      <h1>
        Statistics
        <small>Challenges</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-bar-chart" /> Statistics
        </li>
        <li className="text-bold">
          <Link to="/mpp/stats/challenges">Challenges</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <ChallengesByUser />
    </section>
  </div>
);

export default connect(
  state => ({}),
  dispatch => ({dispatch}),
)(MPPStatsChallenges);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Stats/Challenges/index.tsx